import { isValidLanguage } from '@repo/shared';
import { z } from 'zod';

export const createAudioGenerationWithDatasetSchema = z.object({
  datasetId: z.string(),
  models: z.array(z.string()).min(1),
});

export type CreateAudioGenerationWithDatasetSchema = z.infer<
  typeof createAudioGenerationWithDatasetSchema
>;

export const createAudioGenerationWithFileSchema = z.object({
  files: z.array(z.instanceof(File)),
  models: z.array(z.string()).min(1),
  targetLanguageCode: z.custom<string>(isValidLanguage),
});

export type CreateAudioGenerationWithFileSchema = z.infer<
  typeof createAudioGenerationWithFileSchema
>;
